// 예외처리 4개 탭 공통 — 샘플 CSV 정의 및 생성 유틸
// 헤더/예시행은 각 탭 백엔드 파서가 인식하는 컬럼명 기준(SPEC 4장)

const BOM = '﻿';

/** RFC 4180 규칙으로 셀을 이스케이프 (쉼표/따옴표/개행 포함 시 큰따옴표 래핑) */
function escapeCell(value: string): string {
  if (/[",\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/** 헤더 + 데이터 행 → UTF-8 BOM 포함 CSV 문자열 (Excel 한글 호환) */
export function buildCsv(headers: string[], rows: string[][]): string {
  const lines = [headers, ...rows].map((cols) => cols.map(escapeCell).join(','));
  return BOM + lines.join('\n');
}

export interface SampleCsvSpec {
  filename: string;
  headers: string[];
  example: string[];
}

export const EXCEPTION_SAMPLE_CSV: Record<'nac' | 'wf' | 'dlp' | 'security', SampleCsvSpec> = {
  // NAC (security-exception.service nacExcelUpload — 한글 컬럼)
  nac: {
    filename: 'NAC_예외처리_샘플.csv',
    headers: ['계열사', '이름', 'IP', '예외항목', '적용일', '시작일', '종료일', '사유', '처리자', '적용그룹', '결재문서번호', '비고'],
    example: ['세아홀딩스', '홍길동', '192.168.1.100', 'NAC 로그인 예외', '2026-07-01', '2026-07-01', '2026-12-31', '재택근무', '관리자', '전사기본정책', '결재-2026-001', ''],
  },
  // 유해차단 (parseWfDetailExceptionExcel — 한글 컬럼)
  wf: {
    filename: '유해차단_예외처리_샘플.csv',
    headers: ['요청번호', '예외항목(그룹)', '예외항목(상세)', '신청계열사', '신청부서', '신청자', '대상계열사', '허용IP', '허용PC', 'URL', '사유', '결재문서번호', '처리자', '적용일', '기한', '적용방법', '비고'],
    example: ['1', '웹사이트 예외', '업무용 사이트', '세아홀딩스', 'IT팀', '홍길동', '세아홀딩스', '192.168.1.100', 'PC-001', 'example.com', '업무 필요', '결재-2026-001', '관리자', '2026-07-01', '2026-12-31', '직접적용', ''],
  },
  // DLP (dlp.service processExcelUploadExceptionRequests — snake_case 컬럼)
  // request_no는 서버가 자동 채번하므로 업로드 파일에는 포함하지 않는다.
  // approval = 결재문서번호, remark = 비고 (IPT-632 — remark를 결재문서번호로 오인)
  dlp: {
    filename: 'DLP_예외처리_샘플.csv',
    headers: ['except_group', 'except_detail', 'req_company', 'req_department', 'req_name', 'target_company', 'permitted_ip', 'permitted_pc', 'reason', 'period', 'actor', 'apply_date_display', 'end_date', 'apply_method', 'approval', 'remark'],
    example: ['이동식디스크예외', '매체 예외 등록', '세아홀딩스', 'IT팀', '홍길동', '세아홀딩스', '192.168.1.100', 'PC-001', '업무 필요', '202607', '관리자', '2026-07-01', '2026-12-31', '직접적용', '결재-2026-001', ''],
  },
  // 보안 통합 (security-exception bulk — 기존 유지)
  security: {
    filename: '보안_예외처리_샘플.csv',
    headers: ['solution', 'company', 'exceptionItem', 'exceptionDetail', 'department', 'name', 'reason', 'approvalDocNo', 'applyDate', 'startDate', 'endDate', 'remark'],
    example: ['NAC', '세아홀딩스', 'NAC 로그인 예외', '', 'IT팀', '홍길동', '재택근무', '결재-2026-001', '2026-07-01', '2026-07-01', '2026-12-31', ''],
  },
};

/** 샘플 CSV를 Blob으로 생성해 브라우저 다운로드 */
export function downloadSampleCsv(spec: SampleCsvSpec): void {
  const csv = buildCsv(spec.headers, [spec.example]);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = spec.filename;
  a.click();
  URL.revokeObjectURL(url);
}
